import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useUserProducts = () => {
  const {
    data: products,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['user-products'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error('User not authenticated');

      const { data, error } = await supabase
        .from('products')
        .select(`
          *,
          portfolios!inner(user_id)
        `)
        .eq('portfolios.user_id', user.id)
        .order('created_at', { ascending: false });
      
      if (error) throw error;
      return data;
    }
  });

  return {
    products: products || [],
    isLoading,
    error,
    refetch
  };
};